import styled, {css} from 'styled-components';

export const BorderLightGrey = css`
  border-width: ${(props) => props.theme.border.small};
  border-style: ${(props) => props.theme.border.solid};
  border-color: ${(props) => props.theme.colors.border};
  border-radius: ${(props) => props.theme.border.radius.medium};
`